/**
 * @file コンポーネント：プライバシーポリシー DOM管理
 */

// ライブラリ読み込み
import React from "react";

// コンポーネント読み込み
import { PrivacypolicyEnglish } from "~/src/components/projects/PrivacypolicyEnglish";
import { PrivacypolicyJapanese } from "~/src/components/projects/PrivacypolicyJapanese";
import { Tab } from "~/src/components/projects/Tab";

// スタイル読み込み
import {
    StyledPrivacypolicy,
    StyledPrivacypolicyContainer,
    StyledPrivacypolicyFrame,
    StyledPrivacypolicyLabel,
    StyledPrivacypolicyLabelCheckbox,
    StyledPrivacypolicyLabelText,
    StyledPrivacypolicyParagraph,
} from "./style";

// Presenterを返す
export const Presenter = (props) => {
    // ローカライズデータ
    const localized = window.listLocalized;

    // ReactDOM
    return (
        <StyledPrivacypolicy>
            <StyledPrivacypolicyParagraph data-on-color={props.onColor}>
                {localized["Label.CheckPrivacyPolicy"]}
            </StyledPrivacypolicyParagraph>
            <Tab
                list={[
                    {
                        content: [
                            <StyledPrivacypolicyFrame
                                key="en"
                                data-on-color={props.onColor}
                                ref={props.refFrameEn}
                            >
                                <StyledPrivacypolicyContainer
                                    ref={props.refContainerEn}
                                >
                                    <PrivacypolicyEnglish />
                                </StyledPrivacypolicyContainer>
                            </StyledPrivacypolicyFrame>,
                        ],
                        name: "en",
                        triggerText: "English",
                    },
                    {
                        content: [
                            <StyledPrivacypolicyFrame
                                key="ja"
                                data-on-color={props.onColor}
                                ref={props.refFrameJa}
                            >
                                <StyledPrivacypolicyContainer
                                    ref={props.refContainerJa}
                                >
                                    <PrivacypolicyJapanese />
                                </StyledPrivacypolicyContainer>
                            </StyledPrivacypolicyFrame>,
                        ],
                        hasContent: props.languageCode === "ja", // 日本語がUI表示言語の場合のみ表示
                        name: "ja",
                        triggerText: "日本語",
                    },
                ]}
                onColor={props.onColor}
                selectedTab={props.languageCode}
                triggerSize="full"
            />
            <StyledPrivacypolicyLabel>
                <StyledPrivacypolicyLabelCheckbox
                    defaultChecked={props.isAgreed}
                    disabled={!props.isReaded}
                    onChange={() => props.setIsAgreed(!props.isAgreed)}
                    type="checkbox"
                />
                <StyledPrivacypolicyLabelText data-on-color={props.onColor}>
                    {localized["Label.IAgree"]}
                </StyledPrivacypolicyLabelText>
            </StyledPrivacypolicyLabel>
        </StyledPrivacypolicy>
    );
};
